module.exports = __webpack_public_path__ + "img/download.3970afcf.png";